<script setup lang="ts">
import { useId } from 'vue'

defineProps<{ heading: string, unavailableText?: string }>()

const headingId = useId()
</script>

<template>
  <section :aria-labelledby="headingId" class="mb-5 last:mb-0">
    <div class="mb-2 flex items-center gap-2">
      <h2 :id="headingId" class="text-text-md font-bold uppercase leading-5 text-[#555555]">{{ heading }}</h2>
      <slot name="heading-info" />
    </div>
    <p v-if="unavailableText" class="text-text-md italic leading-5 text-gray-700">{{ unavailableText }}</p>
    <slot v-else :labelled-by="headingId" />
  </section>
</template>
